module.exports = __webpack_public_path__ + "img/terms-of-use-icon.38a02f2a.svg";